import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          welcome: "Welcome",
          login: "Login",
          logout: "Logout",
          signup: "Sign Up",
          name: "Name",
          firstName: "First Name",
          lastName: "Last Name",
          businessName: "Business Name",
          phone: "Phone",
          notAMember: "Not a member?",
          startFreeTrial: "Start Free 14 Days Free Trial",
          email: "Email",
          password: "Password",
          forgotPassword: "Forgot Password?",
          confirmPassword: "Confirm Password",
          resetPassword: "Reset Password",
          sendVerification: "Send Verification",
          updatePassword: "Update Password",
          update:"Update",
          createNewProgram: "Create New Program",
          pointsToCollect: "Points to Collect to get Reward",
          pointsToCollectPlaceholder: "e.g Free Coffee or Free Car Wash or 15% Discount or 10$ Coupon",
          namePlaceholder: "e.g Vit Coffee Shop",
          rewardNamePlaceholder: "e.g Free Coffee or Free Car Wash or 15% Discount or 10$ Coupon",
          rewardName: "Reward Name",
          rewardType: "Reward Type",
          rewardTypeStamp: "Stamp Card (e.g. collect 4 for a free coffee)",
          rewardTypeCouponValue: "Coupon Value (e.g. collect 100 for a 25 SAR coupon)",
          couponValue: "Coupon Value per Reward",
          currencyCode: "Currency",
          emailVerificationRequired: "Email Verification Required",
          verifyNow: "Verify Now",
          daysLeft: "Days Left",
          trialNotice: `Your acount is on {{plan}} plan and it will exprire on {{expiryDate}}.`,
          trialExpired: `Your acount exprired on {{expiryDate}} please subscribe to one of the packages to conitinue using our service.`,
          tExpired:"Trial Expired",
          explorePackages: "Explore Packages",
          dashboard: "Dashboard",
          settings: "Settings",
          customers: "Customers",
          subUsers: "Sub Users",
          sendNotification: "Send Notification",
          customerDetails: "Customer Details",
          editPassTemplate: "Edit Pass Template",
          programs: "Programs",
          program: "Program",
          thankYou: "Thank You",
          home: "Home",
          notFound: "Page Not Found",
          users: "Users",
          verifyNotice: "Verify Notice",
          emailVerificationForm: "Email Verification Form",
          languageChange: "Change Language",
          selectLanguage: "Select Language",
          arabic: "Arabic",
          english: "English",
          signOut: "Sign Out",
          resetLinkSent: "Reset Link sent to your email! Please check your email (and spam folder).",
          resetLinkSentIfExists: "If an account exists for this email, we've sent a password reset link. Please check your inbox (and spam folder).",
          passwordUpdated: "Password updated successfully!",
          passwordUpdateFailed: "Failed to update password. Please try again.",
          resetLinkFailed: "Failed to Reset Link. Please try again.",
          confirmPasswordError: "Confirm Password Should be same as Password",
          emailError: "Email is required",
          passwordError: "Password is required",
          emailVerificationError: "Email Verification Code is required",
          emailVerificationSuccess: "Email Verified Successfully.",
          emailVerificationFailed: "Failed to send Email Verification Code. Please try again.",
          emailVerificationCode: "Email Verification Code",
          
          codeExpiresIn: "Code Expires in: ",
          resendVerificationCode: "Resend Verification Code",
          didntRecieveCode: "Didn't receive the code? Check your spam folder.",
          sendCode: "Send Code",
          verifyCode: "Verify Code",
          emailVerification: "Email Verification",
          verification: "Verification",
          manage: "Manage",
          points: "Points",
          rewardsIssued: "Rewards Issued",
          rewardsRedeemed: "Rewards Redeemed",
          customerRegistrationQrCode: "Customer Registration QR Code",
          recentTransactions: "Recent Transactions",
          date: "Date",
          customer: "Customer",
          description: "Description",
          type: "Type",
          rewards: "Rewards",
          radeemedRewards: "Redeemed Rewards",
          AddedPoiints:  `Added {{num}} points`,
          pointsEacrned: " ⭐ Points Earned",
          rewardRadeemed: "Reward Redeemed",
          rewardRadeemedType: "🎁 Reward Received",
          sentNotificationToCustomer: "Sent Notification to Customer",
          sentNotificationToCustomerType: "🔔 Notification ",
          signedUpType: "📝 Signup ",
          Name: "Name",
          status: "Status",
          statusActive: "Active",
          statusInactive: "Inactive 😔",
          action: "Action",
          searchPlaceholder: "Search with Name or Phone",
          edit:"Edit",
          search: "Search",
          previouse: "Previous",
          next: "Next",
          pageNumber: `Page {{from}} of {{total}} `,
          noData: "No Data Found",
          yourMessage: "Your Message",
          sendMessage: "Send Message",
          sending: "Sending…",
          messageSent: "Message sent ✓",
          details: "Details",
          design: "Design",
          links: "Links",
          location: "Location",
          programDetails: "Program Details",
          inActive:"Inactive 😔",
          send: "Send",
          active:"Active",
          addSubUser:"Add Sub User",
          editSubUser:"Update Sub User",
          saveChanges: "Save Changes",
          uplaodLogo: "Upload Logo Image",
          uploadIcon: "Upload Icon Image",
          uploadStripe: "Upload Stripe background Image",
          uploadPointImage: "Upload Point background Image",
          required: "Required",
          backgroundColor: "Background Color",
          stripeBackgroundColor: "Stripe Background Color",
          textColor: "Text Color",
          addLinks: "Add Links",
          link: "Link",
          "Contact Us to activate the account" : "To Renew/Activate account",
          noLocationFound: "No Location Found",
          addLocation: "Add Location",
          autoNotification: "Auto Notification",
          add: "Add",
          pushUpdates: "Push Updates",
          activate: "Activate",
          "Radeem Reward": "Radeem Reward",
          "No Rewards":"No Rewards",
          passUpdatedSuccessfully: "Pass Design Updated Successfully",
          couldntUploadImage: "Couldnt uplaod image",
          somethingWentWrong: "Something Went Wrong",
          updatingPassDesign: "Updating Pass Design",
          pushingUpdatesToAllPasses : "Pushing Updates To All Passes",
          allPassessUpdatedSuccessfully : "All Passes Updated Successfully",
          ActivatingProgram : "Activating Program",
          programActivatedSuccessfully: "Program Activated Successfully",
          UpdatingPassLinks:"Updating Pass Links",
          passLinksUpdatedSuccessfully: "Pass Links Updated Successfully",
          UpdatingPassLocations : "Updating Pass Locations",
          PassLcoationsUpdatedSuccessfully: "Pass Lcoations Updated Successfully",
          locations: "Locations",
          ActivateProgram : "Activate Program",
          AddNewLocation : "Add New Location",
          UploadLogoImage : "Upload Logo Image",
          UploadIconImage : "Upload Icon Image",
          UploadStripeBackgroundImage : "Upload Stripe Background Image",
          UploadPointImage : "Upload Point Image",
          PassBackgroundColor : "Pass Background Color",
          PassStripeBackgroundColor: "Pass Stripe Background Color",
          
  "imageTooLarge": "Image is Wrong. Max allowed is {{label}}.",


          "Pass Text Color":"Pass Text Color",
          "Save Changes":"Save Changes",
          "Pass Links": "Pass Links",
          "Link": "Link",
          "Add Link": "Add Link",
          "Pass Locations": "Pass Locations",
          "Add Location":"Add Location",
          "Auto Notification" : "Auto Notification",
          "Program Details": "Program Details",
          

            "First name is required": "First name is required",
            "Last name is required": "Last name is required",
            "Business name is required": "Business name is required",
            "Email is required": "Email is required",
            "Invalid email format": "Invalid email format",
            "Phone is required": "Phone is required",
            "Phone must be 8-15 digits": "Phone must be 8-15 digits",
            "Password is required": "Password is required",
            "Password must be at least 6 characters": "Password must be at least 6 characters",
            "Password must be at least 8 characters": "Password must be at least 8 characters"
         ,
          "Add the Auto Notification": "Add the Auto Notification",
          "Search with store name in Google Maps": "Search with store name in Google Maps",
          "Add the notification users get when they are 200 meters close to the location" :"Add the notification users get when they are 200 meters close to the location",
          "Write the address here": "Write the address here",

          createProgram: "Create Program",
          totalCustomers: "Total Customers",
          totalPoints: "Total Points",
          totalRedeemed: "Total Redeemed",
          redemptionRate: "Redemption Rate",
          rewardsAvailable: "rewards available",
          welcomeBack: "Welcome back",
          overviewSubtitle: "Here's an overview of your loyalty programs",
          helpBanner: "Need help setting up? Contact us on WhatsApp",

          activationRate: "Activation Rate",
          activeCustomers: "Active Customers",
          inactiveCustomers: "Inactive Customers",
          avgPoints: "Avg. Points / Customer",
          nearReward: "Close to Reward",
          nearRewardSub: "customers within 75% of reward",
          topCustomers: "Top Customers",
          noTopCustomers: "No customer data yet",
          pointsProgress: "points",
          insights: "Insights",
          programOverview: "Program Overview",
          redeemed: "Redeemed",

          currentStatus: "Current Status",
          currentStatusSub: "All time, as of now",
          activityInPeriod: "Activity",
          last7Days: "7 days",
          last30Days: "30 days",
          last90Days: "90 days",
          last12Months: "12 months",
          customRange: "Custom",
          rangeFrom: "From",
          rangeTo: "To",
          apply: "Apply",
          invalidRange: "Choose a valid range of up to 366 days",
          newCustomers: "New Customers",
          activeInPeriodSub: "earned or redeemed",
          pointsIssued: "Points Issued",
          pointsDeductedSub: "deducted",
          notificationsSentSub: "notifications sent",
          pointsIssuedPerDay: "Points issued per day",
          pointsIssuedPerMonth: "Points issued per month",
          topCustomersInPeriod: "Top Customers in Period",
          earned: "earned",
          rewardsShort: "rewards",
          noActivity: "No activity in this period",
          noTransactionsInRange: "No transactions in this period",
          deductType: "➖ Points Deducted",
          failedToLoad: "Failed to load data",
          keepCurrentPassword: "Leave empty to keep the current password",
        },
      },
      ar: {
        translation: {
          welcome: "مرحبًا",
          login: "تسجيل الدخول",
          startFreeTrial: "ابدأ تجربة مجانية لمدة 14 يومًا",
          notAMember: "لست عضوًا؟",
          logout: "تسجيل الخروج",
          signup: "إنشاء حساب",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          resetPassword: "إعادة تعيين كلمة المرور",
          name: "الاسم",
          firstName: "الاسم الأول",
          lastName: "اسم الاخير",
          businessName: "اسم العمل",
          phone: "رقم التواصل",
          forgotPassword: "نسيت كلمة المرور؟",
          sendVerification: "إرسال رمز التحقق",
          updatePassword: "تحديث كلمة المرور",
          send: "ارسال",
          update:"تحديث",
          createNewProgram: "إنشاء برنامج جديد",
          pointsToCollect: "النقاط التي يجب جمعها للحصول على المكافأة",
          rewardName: "اسم المكافأة",
          rewardType: "نوع المكافأة",
          rewardTypeStamp: "بطاقة ختم (مثال: اجمع 4 نقاط للحصول على قهوة مجانية)",
          rewardTypeCouponValue: "قيمة كوبون (مثال: اجمع 100 نقطة للحصول على كوبون بقيمة 25 ريال)",
          couponValue: "قيمة الكوبون لكل مكافأة",
          currencyCode: "العملة",
          pointsToCollectPlaceholder: "مثل قهوة مجانية أو غسيل سيارة مجاني أو خصم 15% أو قسيمة بقيمة 10$",
          namePlaceholder: "مثل مقهى فيت",
          rewardNamePlaceholder: "مثل قهوة مجانية أو غسيل سيارة مجاني أو خصم 15% أو قسيمة بقيمة 10$",
          programs: "البطاقات",
          edit:"تعديل",
          addSubUser:"اضافة مستخدم فرعي",
          editSubUser:"تحديق مستخدم فرعي",
          dashboard: "لوحة التحكم",
          users: "المستخدمون",
          settings: "الإعدادات",
          customers: "العملاء",
          subUsers: "المستخدمون الفرعيون",
          sendNotification: "إرسال إشعار",
          customerDetails: "تفاصيل العميل",
          editPassTemplate: "تعديل البطاقة",
          program: "البرنامج",
          thankYou: "شكرًا لك",
          home: "الصفحة الرئيسية",
          notFound: "الصفحة غير موجودة",
          "Contact Us" : "تواصل معنا",
          verifyNotice: "إشعار التحقق",
          emailVerificationForm: "نموذج التحقق من البريد الإلكتروني",
          languageChange: "تغيير اللغة",
          selectLanguage: "اختر اللغة",
          arabic: "العربية",
          english: "الإنجليزية",
          signOut: "تسجيل الخروج",
          resetLinkSent: "تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني! يرجى التحقق من بريدك (وصندوق الرسائل غير المرغوب فيها).",
          resetLinkSentIfExists: "إذا كان هناك حساب مرتبط بهذا البريد، فقد أرسلنا رابط إعادة تعيين كلمة المرور. يرجى التحقق من بريدك (وصندوق الرسائل غير المرغوب فيها).",
          passwordUpdated: "تم تحديث كلمة المرور بنجاح!",
          passwordUpdateFailed: "فشل في تحديث كلمة المرور. حاول مرة أخرى.",
          resetLinkFailed: "فشل في إرسال رابط إعادة التعيين. حاول مرة أخرى.",
          confirmPasswordError: "تأكيد كلمة المرور يجب أن يكون مطابقًا لكلمة المرور",
          emailError: "البريد الإلكتروني مطلوب",
          passwordError: "كلمة المرور مطلوبة",
          emailVerificationError: "رمز التحقق من البريد الإلكتروني مطلوب",
          emailVerificationSuccess: "تم توثيق الايميل",
          emailVerificationFailed: "فشل في إرسال رمز التحقق من البريد الإلكتروني. حاول مرة أخرى.",
          emailVerificationCode: "رمز التحقق من البريد الإلكتروني",
          emailVerification: "التحقق من البريد الإلكتروني",
          emailVerificationRequired: "يتطلب التحقق من البريد الإلكتروني",
          vericicationCode: " التحقق",
          codeExpiresIn: "ينتهي الرمز في",
          resendVerificationCode: "إعادة إرسال رمز التحقق",
          didntRecieveCode: "لم تتلق الرمز؟ تحقق من مجلد الرسائل غير المرغوب فيها.",
          resendCode: "إعادة إرسال الرمز",
          verifyNow: "تحقق الآن",
          "Need Help Setting Up Everything We can help you just for 400 SAR we will design setup and teach you how to use the platform Contact Us ":"💡 إذا لا يمكنك تصميم برنامجك فنحن نساعدك!   فقط 400 ريال  — سنقوم بإعداد كل شيء لك ونساعدك أيضًا على فهم كيفية استخدام المنصة",
          verification: "التحقق",
          sendCode: "إرسال الرمز",
          verifyCode: "التحقق من الرمز",
          daysLeft: "الأيام المتبقية",
          trialExpired:  `انتهت صلاحية حسابك في {{expiryDate}} ، يرجى الاشتراك في إحدى الباقات للاستمرار في استخدام خدمتنا.`,
          trialNotice:  "انت مشترك في باقة {{plan}} و سينتهي الاشتراك في {{expiryDate}}",
          tExpired: "انتهت التجربة",
          explorePackages: "استكشف الباقات",
          manage: "إدارة",
          points: "النقاط",
          rewardsIssued: "المكافآت المصدرة",
          rewardsRedeemed: "المكافآت المستبدلة",
          customerRegistrationQrCode: "رمز QR لتسجيل العملاء",
          recentTransactions: "المعاملات الأخيرة",
          date: "التاريخ",
          customer: "العميل",
          description: "الوصف",
          type: "النوع",
          rewards: "المكافآت",
          radeemedRewards: "المكافآت المستبدلة",
          AddedPoiints:  `تمت إضافة {{num}} نقطة`,
          pointsEacrned: " ⭐ النقاط المكتسبة",
          rewardRadeemed: "تم استبدال المكافأة",
          rewardRadeemedType: "🎁 تم استلام المكافأة",
          sentNotificationToCustomer: "تم إرسال إشعار إلى العميل",
          sentNotificationToCustomerType: "🔔 إشعار",
          signedUpType: "📝 تسجيل",
          Name: "الاسم",
          status: "الحالة",
          statusActive: "نشط",
          statusInactive: "غير نشط 😔",
          action: "الإجراء",
          searchPlaceholder: "ابحث بالاسم أو الهاتف",
          search: "بحث",
          active:"فعال",
          inActive:" غير فعال",
          previouse: "السابق",
          next: "التالي",
          pageNumber:  `الصفحة {{from}} من {{total}}`,
          noData: "لا توجد بيانات",
          yourMessage: "رسالتك",
          sendMessage: "إرسال الرسالة",
          sending: "جارٍ الإرسال…",
          messageSent: "تم إرسال الرسالة ✓",
          details: "التفاصيل",
          design: "تصميم",
          links: "الروابط",
          location: "الموقع",
          programDetails: "تفاصيل البرنامج",
          
          "First name is required": "الاسم الأول مطلوب",
          "Last name is required": "اسم الاخير مطلوب",
          "Business name is required": "اسم النشاط التجاري مطلوب",
          "Email is required": "البريد الإلكتروني مطلوب",
          "Invalid email format": "صيغة البريد الإلكتروني غير صحيحة",
          "Phone is required": "رقم الهاتف مطلوب",
          "Phone must be 8-15 digits": "يجب أن يحتوي رقم الهاتف على ٨ إلى ١٥ رقمًا",
          "Password is required": "كلمة المرور مطلوبة",
          "Password must be at least 6 characters": "يجب أن تكون كلمة المرور مكونة من ٦ أحرف على الأقل",
          "Password must be at least 8 characters": "يجب أن تكون كلمة المرور مكونة من ٨ أحرف على الأقل",

          "Contact Us to activate the account":" لتفعيل او تجديد الاشتراك",
          "Radeem Reward": "استخدم الهدية",
          "No Rewards":"لا توجد هدايا",

          saveChanges: "حفظ التغييرات",
          uplaodLogo: "اضافة صورة الشعار",
          uploadIcon: "اضافة صورة الأيقونة",
          uploadStripe: "اضافة صورة خلفية الشريط",
          uploadPointImage: "اضافة صورة خلفية النقاط",
          required: "مطلوب",
          backgroundColor: "لون الخلفية",
          stripeBackgroundColor: "لون خلفية الشريط",
          textColor: "لون النص",
          addLinks: "إضافة روابط",
          link: "رابط",
          noLocationFound: "لم يتم العثور على مواقع",
          addLocation: "إضافة موقع",
          autoNotification: "إشعار تلقائي",
          add: "إضافة",
          pushUpdates: "رفع التحديثات",
          activate: "تفعيل",

          passUpdatedSuccessfully: "تم تحديث تصميم البطاقة بنجاح",
          couldntUploadImage: "تعذر رفع الصورة",
          somethingWentWrong: "حدث خطأ ما",
          updatingPassDesign: "جارٍ تحديث تصميم البطاقة",
          pushingUpdatesToAllPasses: "يتم دفع التحديثات إلى جميع البطاقات",
          allPassessUpdatedSuccessfully: "تم تحديث جميع البطاقات بنجاح",
          ActivatingProgram: "جاري تفعيل البرنامج",
          programActivatedSuccessfully: "تم تفعيل البرنامج بنجاح",
          UpdatingPassLinks: "جارٍ تحديث روابط البطاقة",
          passLinksUpdatedSuccessfully: "تم تحديث روابط البطاقة بنجاح",
          UpdatingPassLocations: "جارٍ تحديث مواقع البطاقة",
          PassLcoationsUpdatedSuccessfully: "تم تحديث مواقع البطاقة بنجاح",
          locations: "المواقع",
          ActivateProgram: "تفعيل البرنامج",
          AddNewLocation: "إضافة موقع جديد",
          UploadLogoImage: "اضافة صورة الشعار",
          UploadIconImage: "اضافة صورة الأيقونة",
          UploadStripeBackgroundImage: "اضافة صورة خلفية الشريط",
          UploadPointImage: "اضافة صورة النقاط",
          PassBackgroundColor: "لون خلفية البطاقة",
          PassStripeBackgroundColor: "لون خلفية الشريط",
          "Pass Text Color": "لون نص البطاقة",
          "Save Changes": "حفظ التغييرات",
          "Pass Links": "روابط البطاقة",
          "Link": "رابط",
          "Add Link": "إضافة رابط",
          "Pass Locations": "مواقع البطاقة",
          "Add Location": "إضافة موقع",
          "Auto Notification": "الإشعارات التلقائية",
          "Program Details": "تفاصيل البرنامج",
          "Next":"التالي",
          "Wrong File Type":"نوع الملف يجب ان يكون jpeg, jpg او png",
          "Description of the location": "وصف الموقع",
          "Add the Auto Notification": "إضافة الإشعار التلقائي",
          
          "Search with store name in Google Maps": "ابحث باستخدام اسم المتجر في خرائط جوجل",
          "Add the notification users get when they are 200 meters close to the location": "أضف الإشعار الذي يظهر للمستخدمين عند اقترابهم من الموقع بمسافة 200 متر",
          "Write the address here": "اكتب العنوان هنا",
              "imageTooLarge": "حجم الصورة غير صحيح الحد الأقصى  {{label}}.",
              "pressToPush": "اضغط على هذا الزر لنشر التغييرات على جميع البطاقات",

          createProgram: "إنشاء برنامج",
          totalCustomers: "إجمالي العملاء",
          totalPoints: "إجمالي النقاط",
          totalRedeemed: "المكافآت المستبدلة",
          redemptionRate: "معدل الاستبدال",
          rewardsAvailable: "مكافأة متاحة",
          welcomeBack: "مرحباً",
          overviewSubtitle: "إليك نظرة عامة على أداء برامج الولاء",
          helpBanner: "تحتاج مساعدة في الإعداد؟ تواصل معنا عبر واتساب",

          activationRate: "معدل التفعيل",
          activeCustomers: "العملاء النشطون",
          inactiveCustomers: "العملاء غير النشطين",
          avgPoints: "متوسط النقاط / عميل",
          nearReward: "قريبون من المكافأة",
          nearRewardSub: "عملاء وصلوا لـ 75% من المكافأة",
          topCustomers: "أفضل العملاء",
          noTopCustomers: "لا توجد بيانات عملاء بعد",
          pointsProgress: "نقطة",
          insights: "الإحصاءات",
          programOverview: "نظرة عامة على البرنامج",
          redeemed: "مستبدل",

          currentStatus: "الوضع الحالي",
          currentStatusSub: "منذ البداية حتى الآن",
          activityInPeriod: "النشاط",
          last7Days: "7 أيام",
          last30Days: "30 يوماً",
          last90Days: "90 يوماً",
          last12Months: "12 شهراً",
          customRange: "مخصص",
          rangeFrom: "من",
          rangeTo: "إلى",
          apply: "تطبيق",
          invalidRange: "اختر فترة صحيحة لا تتجاوز 366 يوماً",
          newCustomers: "عملاء جدد",
          activeInPeriodSub: "كسبوا أو استبدلوا",
          pointsIssued: "النقاط الممنوحة",
          pointsDeductedSub: "مخصومة",
          notificationsSentSub: "إشعارات مرسلة",
          pointsIssuedPerDay: "النقاط الممنوحة يومياً",
          pointsIssuedPerMonth: "النقاط الممنوحة شهرياً",
          topCustomersInPeriod: "أفضل العملاء في الفترة",
          earned: "مكتسبة",
          rewardsShort: "مكافآت",
          noActivity: "لا يوجد نشاط في هذه الفترة",
          noTransactionsInRange: "لا توجد معاملات في هذه الفترة",
          deductType: "➖ خصم نقاط",
          failedToLoad: "تعذر تحميل البيانات",
          keepCurrentPassword: "اتركه فارغاً للإبقاء على كلمة المرور الحالية",

            

        },
      },
    },
    
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    
  });

export default i18n;

